export class DateFormatterUtil {
  /**
   * Formats date string to "dd-MM-yyyy" if not already in that format
   * @param dateString - Input date string
   * @returns Formatted date string
   */
  static formatDate(dateString: string | null): string | null {
    if (!dateString) return dateString;

    const datePattern = /^\d{2}-\d{2}-\d{4}$/;
    if (datePattern.test(dateString)) return dateString;

    const transformedDate = new Date(dateString);
    if (isNaN(transformedDate.getTime())) return dateString;

    return this.formatToddMMyyyyString(transformedDate);
  }

  /**
   * Internal method to format Date to "dd-MM-yyyy" string
   * @param date - Date object to format
   * @returns Formatted date string
   */
  private static formatToddMMyyyyString(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }
}
